import TagManager from "react-gtm-module";

export interface DataLayerEvent {
  event: string;
  userId?: string;
  projectInfo?: any;
  siteInfo?: any;
  areaInfo?: any;
  mowerInfo?: any;
  exportProposalInfo?: any;
  accountLevel?: any;
}

/**
 * Push event to Google Tag Manager dataLayer with automatic cleanup of unused variables
 * All dataLayer variables not specified will be set to undefined to prevent data leakage
 */
export const pushToDataLayer = (eventData: DataLayerEvent): void => {
  const cleanedData: DataLayerEvent = {
    event: eventData.event,
    userId: eventData.userId ?? undefined,
    projectInfo: eventData.projectInfo ?? undefined,
    siteInfo: eventData.siteInfo ?? undefined,
    areaInfo: eventData.areaInfo ?? undefined,
    mowerInfo: eventData.mowerInfo ?? undefined,
    exportProposalInfo: eventData.exportProposalInfo ?? undefined,
    accountLevel: eventData.accountLevel ?? undefined,
  };

  TagManager.dataLayer({
    dataLayer: cleanedData,
  });
};

/**
 * Check if user has given consent for performance/analytics tracking
 * Uses OneTrust/CookieLaw consent groups
 */
export const hasTrackingConsent = (): boolean => {
  try {
    // Check if OneTrust is loaded
    // @ts-ignore - OneTrust global variable
    if (typeof window.OnetrustActiveGroups !== 'undefined') {
      // @ts-ignore
      const activeGroups = window.OnetrustActiveGroups || '';
      // C0002 = Performance Cookies group in OneTrust
      return activeGroups.includes('C0002');
    }
    // If OneTrust is not loaded, assume consent (for development)
    return true;
  } catch (error) {
    console.warn('Could not check tracking consent:', error);
    return false;
  }
};

export const clearTrackingData = (): void => {
  sessionStorage.removeItem('tcsp_user_id');
  sessionStorage.removeItem('tcsp_login_tracked');
  sessionStorage.removeItem('tcsp_user_group');
};

